module.exports = __webpack_public_path__ + "static/media/anc2ru.cc411788.pdf";